import { render } from "./TableComplaining.vue?vue&type=template&id=2c0969ba&scoped=true"
import script from "./TableComplaining.vue?vue&type=script&lang=js"
export * from "./TableComplaining.vue?vue&type=script&lang=js"

import "./TableComplaining.vue?vue&type=style&index=0&id=2c0969ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0969ba"]])

export default __exports__